import React from 'react';
import { BookOpen, ListChecks, AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useReport } from './useReport';
import { ReportFilters } from './ReportFilters';
import { ColumnSelector } from './ColumnSelector';
import { ReportPreview } from './ReportPreview';
import { ExportActions } from './ExportActions';
import { ReportExtras } from './ReportExtras';
import './reports.css';

export const ReportWorkspace = ({ report }) => {
  const state = useReport(report);
  const book = report === 'livro-classe';
  const title = book ? 'Livro de Classe Premium' : 'Lista de Chamada';
  const Icon = book ? BookOpen : ListChecks;
  return <main className={`academic-report ${book ? 'academic-report-book' : ''}`} data-testid={book ? 'livro-classe-page' : 'lista-chamada-page'}>
    <header className="report-page-head">
      <div className="report-brand"><img src="/novo-dna-logo.png" alt="Novo DNA" data-testid="report-official-logo" /><div className="min-w-0"><p data-testid="report-institution-name">NOVO DNA Instituto de Aprendizagem</p><h1 data-testid="report-title">{title}</h1></div></div>
      <span className="report-type-mark" aria-hidden="true"><Icon /></span>
    </header>
    <ReportFilters {...state} />
    <ColumnSelector {...state} />
    <ExportActions report={report} {...state} />
    {state.error && <div className="report-error" role="alert" data-testid="report-error"><AlertCircle className="h-5 w-5 shrink-0" /><span className="min-w-0 break-words">{String(state.error)}</span><Button variant="ghost" size="sm" onClick={state.refresh} data-testid="report-retry"><RefreshCw className="h-4 w-4 mr-1" />Tentar novamente</Button></div>}
    <ReportPreview title={title} {...state} />
    {!book && <ReportExtras params={state.params} ready={state.ready && !!state.preview?.rows.length && !state.loading} />}
  </main>;
};